import React, { FunctionComponent } from 'react';
import MuiButton, { ButtonProps } from '@material-ui/core/Button';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import { pickClassNames } from '../../utils';
import CircularLoader from '../CircularLoader';
import styles from './styles';

type TTooltipProps = {
  title: TooltipProps['title'];
  placement: TooltipProps['placement'];
};

type TButtonProps = ButtonProps & {
  shouldDisplayProgress?: boolean;
  tooltipProps?: TTooltipProps;
};

const Button: FunctionComponent<TButtonProps> = ({
  children,
  className,
  onClick,
  disabled,
  color = 'primary',
  shouldDisplayProgress,
  tooltipProps,
  ...rest
}) => {
  const classes = styles();
  const pickedClassNames = pickClassNames(classes, [
    'root',
    shouldDisplayProgress ? 'inProgress' : '',
  ]);
  const button = (
    <MuiButton
      className={`${className} ${pickedClassNames}`}
      classes={{
        label: classes.label,
      }}
      onClick={onClick}
      color={color}
      disabled={disabled || shouldDisplayProgress}
      {...rest}
    >
      {shouldDisplayProgress ? <CircularLoader size={15} /> : children}
    </MuiButton>
  );

  if (tooltipProps) {
    return (
      <Tooltip {...tooltipProps}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default Button;
